import { ModeAndThemeOption } from "@/pages/user-settings/mode-theme";
import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import "./styles/PopupSelectTemplate.css";

const FORMAT_OPTIONS = [
  {
    id: "story",
    label: "Story",
    subtitle: "1080 x 1920 px",
  },
  {
    id: "post",
    label: "Post",
    subtitle: "1080 x 1350 px",
  },
];

const MODE_OPTIONS = [
  {
    id: "dark",
    label: "Dark",
    className: "dark-mode mode",
  },
  {
    id: "light",
    label: "Light",
    className: "light-mode mode",
  },
];

const PopupSelectTemplate = ({
  open,
  onClose,
  onGoBack,
  selectedFormat,
  onSelectFormat,
  selectedMode,
  onSelectMode,
  onContinue,
}) => {
  const handleGoBack = onGoBack || onClose;

  return (
    <GenericPopup
      open={open}
      className="artwork-options__download-template-container download-template-step__container"
      opacity
      onTouchStart={(event) => event.stopPropagation()}
      onTouchEnd={(event) => event.stopPropagation()}
      onWheel={(event) => event.stopPropagation()}
    >
      <div className="download-template-step__header">
        <BackArrowIcon className="download-template-step__back" onClick={handleGoBack} />
        <p className="download-template-step__title">Generate template</p>
        <p className="download-template-step__subtitle">
          <span>1.</span>
          Choose template format and mode
        </p>
        <XIcon className="download-template-step__close" onClick={onClose} />
      </div>

      <div className="download-template-step__formats">
        {FORMAT_OPTIONS.map((option) => {
          const isActive = selectedFormat === option.id;

          return (
            <button
              key={option.id}
              type="button"
              className={`download-template-step__format-card ${
                isActive ? "active" : ""
              }`}
              onClick={() => onSelectFormat(option.id)}
            >
              <div
                className={`download-template-step__format-illustration ${option.id} ${selectedMode || "dark"}`}
                aria-hidden
              />
              <div className="download-template-step__format-copy">
                <span>{option.label}</span>
                <small>{option.subtitle}</small>
              </div>
            </button>
          );
        })}
      </div>

      <div className="download-template-step__mode">
        <p className="download-template-step__mode-label">Mode</p>
        <div className="download-template-step__mode-options">
          {MODE_OPTIONS.map((option) => (
            <ModeAndThemeOption
              key={option.id}
              className={`download-template-step__mode-option ${option.className}`}
              text={option.label}
              isActive={selectedMode === option.id}
              onClick={() => onSelectMode(option.id)}
            />
          ))}
        </div>
      </div>

      <ContinueButton
        className={`download-template-step__cta ${selectedFormat ? "active" : ""}`}
        onClick={onContinue}
        turnOff={!selectedFormat}
      >
        Continue
      </ContinueButton>
    </GenericPopup>
  );
};

export default PopupSelectTemplate;
